import React from 'react';
import {Icon} from '@lightricks/react-design-system';
import useNavigation from '@/hooks/use-navigation';

type BackButtonProps = {
  testID?: string;
  onBackClick?: (navigation: {
    goBack: () => void;
    navigate: (to: string, params?: any) => void;
  }) => void;
  backIcon?: React.ReactNode;
};

function BackButton(props: BackButtonProps) {
  const {
    testID = 'back-button',
    onBackClick,
    backIcon = (
      <Icon size="large" appearance="neutral" name="Actions-Arrow-Back-Small" />
    ),
  } = props;
  const navigation = useNavigation();

  const onClick = () => {
    if (onBackClick) {
      onBackClick(navigation);
      return;
    }
    navigation.goBack();
  };

  return (
    <div data-testid={testID} onClick={onClick}>
      {backIcon}
    </div>
  );
}

export default BackButton;
